







































import { Component, mixins, Prop } from 'nuxt-property-decorator'
import '~/assets/scss/v-tooltip.scss'
import { mdiPhone, mdiEmailOutline } from '@mdi/js'
import { IImageVariants } from '~/assets/interfaces/images'
import MixinGeneral from '~/assets/mixins/general'
import { filterPhone } from '~/assets/filters/phone'
import { filterEmail } from '~/assets/filters/email'
import ComponentIcon from '~/components/icon/icon.vue'
import ComponentImage from '~/components/images/image.vue'

@Component({
  components: {
    ComponentImage,
    ComponentIcon,
  },
  filters: {
    filterPhone,
    filterEmail,
  },
})
export default class ComponentStoresItem extends mixins(MixinGeneral) {
  @Prop({ type: [Object, String], default: null })
  readonly image!: IImageVariants

  @Prop({ type: String }) readonly url!: string
  @Prop({ type: String }) readonly address!: string
  @Prop({ type: String }) readonly title!: string
  @Prop({ type: String }) readonly time!: string
  @Prop({ type: String }) readonly email!: string
  @Prop({ type: String }) readonly phone!: string

  @Prop({ type: Boolean, default: false }) readonly hideImageColumn: string

  private icons = {
    mdiPhone,
    mdiEmailOutline,
  }

  private get itemStyles() {
    if (!this.$device.isMobileOrTablet) {
      return {
        gridTemplateColumns: this.hideImageColumn ? '1fr 300px' : '1fr 5fr',
      }
    }
  }
}
